export type UserPermissions =
  'project:read' |
  'project:create' |
  'project:update' |
  'project:delete' |
  
  'record:read' |
  'record:create' |
  'record:update' |
  'record:delete' |
  'record:actions' |
  
  'team:update' |
  
  'user:read' |
  'user:invite' |
  'user:update' |
  'user:delete' |
  
  'admin:all';

export class Team {
  id?: string;
  name?: string;
  permissions?: UserPermissions[];
}

export class User {
  id?: string;
  name?: string;
  email?: string;
  role?: string;    // admin, user
  photoUrl?: string;
  team?: Team;
  status?: string; // pending, active, blocked
}

export class TeamUsers {
  team?: Team;
  users: User[] = [];
}